var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "CreateComment" } }, [
    _c("h3", [_vm._v(_vm._s(_vm.$t("task.comments")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "add-comment" },
      [
        _c("Avatar", {
          attrs: { size: 35, src: _vm.user.gravatar, username: _vm.user.name },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.commentText,
              expression: "commentText",
            },
          ],
          staticClass: "comment-input",
          attrs: { type: "text", placeholder: _vm.$t("task.addAComment") },
          domProps: { value: _vm.commentText },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.commentText = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "comment-submit-btn",
            on: { click: _vm.submitComment },
          },
          [_vm._v(_vm._s(_vm.$t("task.addComment")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }